import qs from 'qs'
import {containsQueryParameter, getSessionProperty, removeSessionProperty} from './sessionProperties'
import {
  removeAllOfferSessionProperties
} from "./offer";
export const COURSE_CODE_SESSION_STORAGE_KEY = 'COURSE_CODE'
export const COURSE_SUMMARY_SESSION_STORAGE_KEY = 'COURSE_SUMMARY'
export const COURSE_ID_QUERY_PARAMETER = 'courseid'

export const getCourseCode = searchLocation => {
  removeCourseSessionStorageItemsIfQueryParameterFound(searchLocation, COURSE_ID_QUERY_PARAMETER);

  return getSessionProperty(
    COURSE_CODE_SESSION_STORAGE_KEY,
    COURSE_ID_QUERY_PARAMETER,
    searchLocation
  )
}

export const removeCourseSessionStorageItemsIfQueryParameterFound = (searchLocation, queryParameter) => {
  if (containsQueryParameter(searchLocation, queryParameter, true)) {
    removeAllCourseSessionProperties();
    removeAllOfferSessionProperties();
  }
}

export const removeAllCourseSessionProperties = () => {
  removeSessionProperty(COURSE_CODE_SESSION_STORAGE_KEY);
  removeSessionProperty(COURSE_SUMMARY_SESSION_STORAGE_KEY);
  //removeSessionProperty('COURSE_ID');
}

export const getCourseId = () => {
  return getCourseCode()
}

export const setCourseId = courseId => {
  sessionStorage.setItem(COURSE_CODE_SESSION_STORAGE_KEY, courseId)
}

export const getCourseIdProperty = queryParams => {
  return Object.keys(queryParams).find(
    queryParam => queryParam.toLocaleLowerCase() === 'courseid'
  )
}

export const setCourseIdViaQueryParameter = searchLocation => {
  let courseId = getCourseCode(searchLocation)
  const queryParams = qs.parse(searchLocation, {
    ignoreQueryPrefix: true
  })
  const courseIdProperty = getCourseIdProperty(queryParams)
  if (courseIdProperty && queryParams.hasOwnProperty(courseIdProperty)) {
    setCourseId(courseId)
  }
  return courseId
}
